module.exports = __webpack_public_path__ + "static/media/file-view-png.df6b0e65.svg";